"use strict";

function CustomSelect() {
  var selects = document.querySelectorAll('.custom-select');
  selects.forEach(function (wrapper) {
    if (wrapper.dataset.customSelect === 'true') return;
    wrapper.dataset.customSelect = 'true';
    var trigger = wrapper.querySelector('.custom-select__trigger');
    var value = wrapper.querySelector('.custom-select__value');
    var options = wrapper.querySelectorAll('.custom-select__option');
    var input = wrapper.querySelector('input[type="hidden"], select');
    if (!trigger || !value || !options.length) return;
    var placeholder = value.textContent.trim();
    function open() {
      wrapper.classList.add('is-open');
    }
    function close() {
      wrapper.classList.remove('is-open');
    }
    function setValue(option) {
      var optionValue = option.dataset.value || '';
      var optionText = option.textContent.trim();
      value.textContent = optionText || placeholder;
      value.classList.toggle('custom-select__value--placeholder', !optionValue);
      if (input) {
        input.value = optionValue;
        input.dispatchEvent(new Event('change', {
          bubbles: true
        }));
      }
      options.forEach(function (item) {
        item.classList.toggle('is-selected', item === option);
      });
      close();
    }
    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (wrapper.classList.contains('is-open')) {
        close();
      } else {
        document.querySelectorAll('.custom-select.is-open').forEach(function (el) {
          if (el !== wrapper) el.classList.remove('is-open');
        });
        open();
      }
    });
    options.forEach(function (option) {
      option.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        setValue(option);
      });
    });
    document.addEventListener('click', function (event) {
      if (!wrapper.contains(event.target)) close();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') close();
    });
    var selected = Array.from(options).find(function (option) {
      return option.classList.contains('is-selected') && option.dataset.value;
    });
    if (selected) {
      setValue(selected);
    } else {
      value.classList.add('custom-select__value--placeholder');
      if (input) input.value = '';
    }
  });
}
CustomSelect();